export function getdata() {
	let obj = {
		headData: [{
				title: "指标名称",
				prop: "zbmc",
				// custom: true,
			},
			{
				title: "预警值",
				prop: "hej",
				align: "right"
			},
			{
				title: "当前值",
				prop: "tax0",
				align: "right",
			},
		],
	}
	return obj
}
